import { createFileRoute } from '@tanstack/react-router'

import { DmsVolumeScreen } from './-components/dms-volume-screen.tsx'

export const Route = createFileRoute('/business-performance/dms-volume')({
  component: DmsVolumeScreen
})
